import { Cookie } from "@modules/util/Cookie"

// ---- Start Cookie ---- //
if ("undefined" !== typeof Cookie && siteConfig.bannerCookieName) {
    const expiresDate = new Date()

    expiresDate.setHours(24, 1, 0, 0)
    const overlayCookie = new Cookie(siteConfig.bannerCookieName, {
        path: "/",
        domain: SiteInfo.cookieDomain,
        expires: expiresDate.toUTCString(),
    })

    const cookieValue = overlayCookie.value || {}
    cookieValue[siteConfig.bannerCookieId] = siteConfig.bannerCookieValue

    overlayCookie.secure = true
    overlayCookie.value = cookieValue
}
// ---- Ende Cookie ---- //

// ---- Start Onclick Cookie ---- //
if ("undefined" !== typeof Cookie && siteConfig.bannerCookieName) {
    // xxlbanner:onclose = desktopHeader.js -> close Banner Event
    $(document).on("xxlbanner:onclose", () => {
        const expiresDate = new Date()

        expiresDate.setHours(24, 1, 0, 0)
        const overlayCookie = new Cookie(siteConfig.bannerCookieName, {
            path: "/",
            domain: SiteInfo.cookieDomain,
            expires: expiresDate.toUTCString(),
        })

        const cookieValue = overlayCookie.value || {}
        cookieValue[siteConfig.bannerCookieId] = siteConfig.bannerCookieValue

        overlayCookie.secure = true
        overlayCookie.value = cookieValue
    })
}
// ---- Ende Onclick Cookie ---- //
